var map = {
	"./air-nga-en/assets/favicon.png": 18992,
	"./ais-tai-en/assets/favicon.png": 49213,
	"./ais-tai-tha/assets/favicon.png": 21817,
	"./demo-arabic/assets/favicon.png": 38641,
	"./demo-et-en/assets/favicon.png": 6036,
	"./demo-romanian/assets/favicon.png": 79358,
	"./demo-um-en/assets/favicon.png": 90481,
	"./dtac-tai-en/assets/favicon.png": 9022,
	"./dtac-tai-tha/assets/favicon.png": 17448,
	"./ethiotel-et-amh/assets/favicon.png": 23258,
	"./ethiotel-et-en/assets/favicon.png": 40419,
	"./mtn-cg-fr/assets/favicon.png": 82306,
	"./mtn-ci-fr/assets/favicon.png": 19384,
	"./mtn-cmr-fr/assets/favicon.png": 99676,
	"./mtn-gha-en/assets/favicon.png": 9291,
	"./mtn-nga-en/assets/favicon.png": 13727,
	"./mtn-zam-en/assets/favicon.png": 14481,
	"./saf-ke-en/assets/favicon.png": 84972,
	"./saudi-uae-en/assets/favicon.png": 82465,
	"./tlk-za-en/assets/favicon.png": 83440,
	"./vc-za-en/assets/favicon.png": 8508
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96340;